import Columns from './columns';

export default {
  editorial: {
    columns: [
      Columns.Entrant,
      Columns.Email,
      Columns.EntryDate
    ],
    documentTitle: 'Sweeps Entries',
    topLevelClassName: 'editorial-entries',
    spinnerMessage: 'loading.entries',
    dateFormat: 'MM/DD/YY'
  },

  sponsored: {
    columns: [
      Columns.Entrant,
      Columns.Email,
      Columns.EntryDate,
      Columns.WinDate,
      Columns.ForfeitDate
    ],
    documentTitle: 'Sponsored Entries',
    topLevelClassName: 'sponsored-entries',
    spinnerMessage: 'loading.entries',
    dateFormat: 'MM/DD/YY'
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListEntries/configs.js